// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"AgileItem_itemContainer__TDVuS","imgContainer":"AgileItem_imgContainer__1SUib","textContainer":"AgileItem_textContainer__2LxLH"};